import {useParams, useLocation} from "react-router-dom";
import Box from "@mui/material/Box";
import React, {useState} from "react";
import TextField from "@material-ui/core/TextField/TextField";
import {Button, styled} from '@mui/material';
import {isObjectEmpty} from "../utils/utils";
import {YesNoDialog} from "../components/yes-no-dialog";
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import {approveCourt, rejectCourt} from "../firebase";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import Alert from "@material-ui/core/Alert/Alert";

const CustomTextField = styled(TextField)({
    '& .MuiInputBase-root.Mui-disabled': {
        backgroundColor: 'rgba(0, 255, 0, 0.1)',
    },
});

export function CourtCorrectionsDetail() {
    const {id} = useParams();
    const {state} = useLocation();

    const handleCloseSnackbar = () => setSnackbar(null);
    const [snackbar, setSnackbar] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [dialogType, setDialogType] = useState(null);
    const [dialogData, setDialogData] = useState(null);

    if (isObjectEmpty(state)) {
        return (<div>No data found</div>);
    }

    const {courtId, firstName, lastName, additionalNotes, noLongerExists, oldCourtInfo, newCourtInfo} = state;

    console.log('oldCourtInfo', oldCourtInfo)
    console.log('newCourtInfo', newCourtInfo)

    if (!id || isObjectEmpty(oldCourtInfo) || isObjectEmpty(newCourtInfo)) {
        return (<div>No data found</div>);
    }

    const renderOldNewFields = (key, label, oldCourtInfoValue, newCourtInfoValue) => {
        return (
            <>
                <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <TextField
                        id={`old-${key}`}
                        label={label}
                        value={oldCourtInfoValue}
                        disabled={true}
                        fullWidth
                    />

                    <Box sx={{px: 1}}/>

                    {oldCourtInfoValue !== newCourtInfoValue
                        ? <CustomTextField
                            id={`new-${key}`}
                            label={label}
                            value={newCourtInfoValue}
                            disabled={true}
                            fullWidth />
                        : <TextField
                            id={`new-${key}`}
                            label={label}
                            value={newCourtInfoValue}
                            disabled={true}
                            fullWidth />
                    }
                </Box>

                <Box sx={{py: 1}}/>
            </>
        )
    };

    const handleNo = () => {
        setShowDialog(false);
    };

    const handleYes = async () => {

        try {
            if (dialogType == 'confirm') {

                // TODO: implement
                // await approveUpdateCourtInfo(courtData);

                setSnackbar({children: 'Court update approved', severity: 'success'});
            } else if (dialogType == 'decline') {
                // TODO: implement
                // await rejectUpdateCourtInfo(courtData);

                setSnackbar({children: 'Court update declined', severity: 'error'});
            }

            setShowDialog(false);

        } catch (error) {
            setSnackbar({ children: "There was a server issue. Please try again later.", severity: 'error' });
        }
    };

    const confirm = () => {
        setShowDialog(true);
        setDialogType('confirm');
    };

    const decline = () => {
        setShowDialog(true);
        setDialogType('decline');
    };

    const renderConfirmDialog = () => {
        return (
            <YesNoDialog
                showDialog={showDialog}
                yesButtonPressed={handleYes}
                noButtonPressed={handleNo}
                dialogTitle={dialogType == 'confirm'
                    ? 'Are you sure you want to approve this updated court info?'
                    : 'Are you sure you want to reject this updated court info?'}
            />
        );
    };

    return (
        <>
            {renderConfirmDialog()}
            {!!snackbar && (<Snackbar
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                onClose={handleCloseSnackbar}
                autoHideDuration={3000}
                open={true}
                key={'top' + 'center'}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{width: '100%'}}>
                    {snackbar.children}
                </Alert>
            </Snackbar>)}

            <div>{`CourtId: ${id}`}</div>
            <div>{`Submitted by: ${firstName} ${lastName}`}</div>
            <div>{`No Longer Exists?: ${noLongerExists}`}</div>
            <div>{`Additional Notes: ${additionalNotes}`}</div>

            <Box   sx={{
                py: 3,
            }}>
                <Button
                    sx={{mr: 1}}
                    variant="outlined"
                    color="primary"
                    endIcon={<CancelIcon sx={{color: 'red'}} fontSize="small"/>}
                    size="small"
                    onClick={decline}
                >
                    Reject
                </Button>

                <Button
                    variant="outlined"
                    color="primary"
                    endIcon={<CheckIcon sx={{color: 'green'}} fontSize="small"/>}
                    size="small"
                    onClick={confirm}
                >
                    Approve
                </Button>

            </Box>

            {noLongerExists ? null :
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        py: 3,
                        flexDirection: 'column',
                        display: 'flex'
                    }}
                >
                    {renderOldNewFields('name', 'Name', oldCourtInfo.name, newCourtInfo.name)}
                    {renderOldNewFields('address', 'Address', oldCourtInfo.formattedAddress, newCourtInfo.formattedAddress)}
                    {renderOldNewFields('numberCourts', 'Number of courts', oldCourtInfo.numberOfCourts, newCourtInfo.numberOfCourts)}
                    {renderOldNewFields('phone', 'Phone', oldCourtInfo.phoneNumber, newCourtInfo.phoneNumber)}
                    {renderOldNewFields('website', 'Website', oldCourtInfo.website, newCourtInfo.website)}
                    {renderOldNewFields('public', 'Is Public?', oldCourtInfo.isPublic, newCourtInfo.isPublic)}
                    {renderOldNewFields('hasLights', 'Has Lights?', oldCourtInfo.hasLights, newCourtInfo.hasLights)}
                    {renderOldNewFields('isIndoor', 'Is Indoors?', oldCourtInfo.isIndoor, newCourtInfo.isIndoor)}
                    {renderOldNewFields('hasFees', 'Has Fees?', oldCourtInfo.hasFees, newCourtInfo.hasFees)}

                </Box>
            }
        </>
    );
};